<script>
  import bus from '@utils/bus'
  export default {
    name: 'navigation-buttons',
    props: ['showPrevious', 'showNext', 'previousClick', 'nextClick', 'disablePrevious', 'disableNext', 'confirm', 'close'],
    methods: {
      fecharJanela () {
        bus.$emit('fecharJanelaMatricula')
      }
    },
    mounted () {
      bus.$on('desabilitaConfirma', () => {
        this.disableNext = true
      })
    }
  }
</script>

<template>
    <div class="flex-header pa-0"  style="width:100%">
        <v-layout row wrap>
            <v-flex  pa-0  ma-0 xs6 sm3 md3 lg3>              
                <div v-if="!showPrevious"></div>
                <v-layout align-end justify-start row>
                    <v-btn v-show="showPrevious" flat large class="primary" sm4 xs12
                        :disable="disablePrevious"
                        @click="previousClick()">
                        <i class="fas fa-arrow-left"></i>
                        <span class="mr-2">&nbsp;&nbsp;Voltar</span>
                    </v-btn>
                </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex  pa-0 ma-0 xs6 sm3 md3 lg3 >
                <v-layout row wrap align-end justify-end>
                    <v-btn v-show="showNext" flat large class="success"
                            :disabled="disableNext"
                            @click="nextClick()">

                        <template v-if="confirm">
                            <i class="fas fa-check"></i>
                            <span class="mr-2">&nbsp;&nbsp;Confirmar</span>
                        </template>
                        <template v-else-if="close">
                            <i class="fas fa-times"></i>
                            <span class="mr-2">&nbsp;&nbsp;Fechar</span>
                        </template>
                        <template v-else>
                            <span class="mr-2">Avançar</span>
                            <i class="fas fa-arrow-right"></i>                        
                        </template>
                        
                    </v-btn>
                </v-layout>
            </v-flex>
            
        </v-layout>
    </div>
</template>



// WEBPACK FOOTER //
// NavigationButtons.vue?220582c1